// Button Color Math - Calculate shadow color with -50 luma
// Converts RGB to Lab, reduces luma by 50, converts back to hex

function rgbToLab(r, g, b) {
  // Normalize RGB to 0-1
  r /= 255;
  g /= 255;
  b /= 255;

  // Apply gamma correction
  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

  // Convert to XYZ
  let x = r * 0.4124 + g * 0.3576 + b * 0.1805;
  let y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  let z = r * 0.0193 + g * 0.1192 + b * 0.9505;

  // Normalize by reference white (D65)
  x /= 0.95047;
  y /= 1.0;
  z /= 1.08883;

  // Convert XYZ to Lab
  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16/116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16/116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16/116);

  let L = (116 * y) - 16;
  let a = 500 * (x - y);
  let b_val = 200 * (y - z);

  return { L, a, b: b_val };
}

function labToRgb(L, a, b) {
  // Convert Lab to XYZ
  let y = (L + 16) / 116;
  let x = a / 500 + y;
  let z = y - b / 200;

  // Apply inverse function
  let x3 = Math.pow(x, 3);
  let y3 = Math.pow(y, 3);
  let z3 = Math.pow(z, 3);

  x = x3 > 0.008856 ? x3 : (x - 16/116) / 7.787;
  y = y3 > 0.008856 ? y3 : (y - 16/116) / 7.787;
  z = z3 > 0.008856 ? z3 : (z - 16/116) / 7.787;

  // Normalize by reference white (D65)
  x *= 0.95047;
  y *= 1.0;
  z *= 1.08883;

  // Convert XYZ to RGB
  let r = x *  3.2406 + y * -1.5372 + z * -0.4986;
  let g = x * -0.9689 + y *  1.8758 + z *  0.0415;
  let b_val = x *  0.0557 + y * -0.2040 + z *  1.0570;

  // Apply inverse gamma correction
  r = r > 0.0031308 ? 1.055 * Math.pow(r, 1/2.4) - 0.055 : 12.92 * r;
  g = g > 0.0031308 ? 1.055 * Math.pow(g, 1/2.4) - 0.055 : 12.92 * g;
  b_val = b_val > 0.0031308 ? 1.055 * Math.pow(b_val, 1/2.4) - 0.055 : 12.92 * b_val;

  // Clamp and convert to 0-255
  r = Math.max(0, Math.min(255, Math.round(r * 255)));
  g = Math.max(0, Math.min(255, Math.round(g * 255)));
  b_val = Math.max(0, Math.min(255, Math.round(b_val * 255)));

  return { r, g, b: b_val };
}

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

function rgbToHex(r, g, b) {
  return "#" + [r, g, b].map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }).join("").toUpperCase();
}

function getDarkerHex(hexColor, lumaReduction = 50) {
  // Convert hex to RGB
  const rgb = hexToRgb(hexColor);
  if (!rgb) return hexColor;

  // Convert RGB to Lab
  const lab = rgbToLab(rgb.r, rgb.g, rgb.b);

  // Reduce luma
  lab.L = Math.max(0, lab.L - (lumaReduction / 100 * 100));

  // Convert back to RGB
  const newRgb = labToRgb(lab.L, lab.a, lab.b);

  // Convert to hex
  return rgbToHex(newRgb.r, newRgb.g, newRgb.b);
}

function rgbStringToHex(rgbString) {
  const rgbMatch = rgbString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (rgbMatch) {
    return rgbToHex(parseInt(rgbMatch[1]), parseInt(rgbMatch[2]), parseInt(rgbMatch[3]));
  }
  return null;
}

// Calculate shadow colors and set as CSS variables on all buttons
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.button, .folder-product-tab');
  
  buttons.forEach(btn => {
    const computedStyle = window.getComputedStyle(btn);
    const bgColor = computedStyle.backgroundColor;

    // Convert rgb(r, g, b) to hex
    const bgHex = rgbStringToHex(bgColor);
    
    if (bgHex) {
      // Calculate shadow color (-50 luma from button color)
      const shadowColor = getDarkerHex(bgHex, 50);
      
      // Set CSS variable for shadow on button
      btn.style.setProperty('--button-shadow-color', shadowColor);
    }
  });

  // Also apply shadow color to product badges in tabs
  const productTabs = document.querySelectorAll('.product-tab, .folder-product-tab, .product-grid-card');
  productTabs.forEach(tab => {
    // Find the button color from global color scheme
    // Get from parent section's color scheme or use computed style
    const section = tab.closest('.product-selector');
    if (section) {
      const computedStyle = window.getComputedStyle(section);
      // Try to get button color from CSS variables
      const btnColor = computedStyle.getPropertyValue('--color-button').trim();
      
      if (btnColor) {
        // btnColor is in "R, G, B" format, convert to hex
        const rgbString = `rgb(${btnColor})`;
        const bgHex = rgbStringToHex(rgbString);
        
        if (bgHex) {
          const shadowColor = getDarkerHex(bgHex, 50);
          const badge = tab.querySelector('.product-badge');
          if (badge) {
            badge.style.setProperty('--button-shadow-color', shadowColor);
          }
        }
      }
    }
  });
});
